import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '@spartacus/core';

@Pipe({
    name: 'cxTranslateAndFormat',
    standalone: false
})
export class TranslateAndFormatPipe implements PipeTransform {
    constructor(private trser: TranslationService) { }
    transform(message: any): string {
        if (!message || !message.message || !message.url || !message.message2) {
            return '';
        }

        const translatedMessage1 = this.translate(message.message);
        const translatedMessage2 = this.translateSplitter(message.message2);
        const regex = />([^<]+)<\/a>(.*)/;
        const matches = translatedMessage2.match(regex);
        let part1;
        let part2;
        if (matches) {
            part1 = matches[1].trim(); // 'product detail page'
            part2 = matches[2].trim(); // 'for more information.'

        }
        return `${translatedMessage1} <a href='${message.url}'>${part1}</a> ${part2}`;
    }

    private translate(text: string): string {
        let retext;
        this.trser.translate(text).subscribe((x) => {
            retext = x.replace('<a href', '');
        });
        return retext;

    }
    private translateSplitter(text: string): string {
        let retext;
        this.trser.translate(text).subscribe((x) => {
            retext = x;
        })
        return retext;

    }
}
